import { Z_INDEX } from '@/constants/z-index'
import { useStyletron } from 'baseui'
import { StyleObject } from 'styletron-react'
import { ReactNode } from 'react'

type ContextMenuContainerProps = {
  id: string
  children: ReactNode
  onMouseEnter?: () => void
  style?: StyleObject
}

function ContextMenuContainer({ id, children, onMouseEnter, style }: ContextMenuContainerProps) {
  const [css] = useStyletron()

  return (
    <div
      id={id}
      data-context-menu-submenu="true"
      className={css({
        zIndex: Z_INDEX.CONTEXT_MENU,
        backgroundColor: '#ffffff',
        borderRadius: '16px',
        filter: 'drop-shadow(0 0 12px rgba(0, 0, 0, 0.15))',
        padding: '16px',
        display: 'flex',
        flexDirection: 'column',
        width: '235px',
        ...style,
      })}
      onMouseEnter={onMouseEnter}
    >
      {children}
    </div>
  )
}

export default ContextMenuContainer
